import { AxiosUpdateTuple, usePutAxiosHook } from '../../AxiosPutHook';

const URL = '/api/clients/update-communication-flag';

export const useUpdateClientCommunicationFlag = (): AxiosUpdateTuple => {
  const [callBack, { data, loading, called, error }] = usePutAxiosHook(URL);

  return [callBack, { data, loading, called, error }];
};
